<form [formGroup]="form"
      [exitConfirmation]="comfirmOnClose ? form : null"
      (ngSubmit)="submit(form, false)" novalidate>
    <h1 class="print-mode" *ngIf="printMode">
        <span class="d-inline-block text-truncate w-100">{{ title }}</span>
        <h6>{{ itemTitle }}</h6>
        <h6>{{ userName }}</h6>
    </h1>
    <h1 [ngClass]="{ main: true, 'modal-header': modalMode, 'sticky-top': !modalMode && !!close }">
        <div *ngIf="!printMode" class="row">
            <div [ngClass]="{ 'modal-title': modalMode }" class="text-truncate col-lg pt-0 mb-lg-0 mb-2">{{ title }}</div>
            <div class="col-lg-auto">
                <ul class="actions float-end">
                    <li>
                        <a [href]="printUrl" target="_blank" class="btn btn-info me-sm-2"><i class="fas fa-print" aria-hidden="true"></i></a>
                    </li>
                    <li *ngIf="!previewMode">
                        <button type="button" class="btn btn-primary me-sm-2" [ladda]="busy" (click)="submit(form, true)" *ngIf="userForm && userForm.Status === UserFormStatus.OPEN" [disabled]="form.pristine || IsMasterComplete">Save Draft</button>
                        <button type="submit" class="btn btn-primary me-sm-2" [ladda]="busy" *ngIf="!isFormLocked()" [disabled]="form.invalid || IsMasterComplete">Complete Form</button>
                        <button type="button" class="btn btn-secondary me-sm-2" [ladda]="busy" (click)="unlockForm()" *ngIf="isFormLocked() && !IsHistory && !IsMasterComplete">Override Form</button>
                    </li>
                    <li *ngIf="close">
                        <button type="button" (click)="close()" class="btn btn-info">Close</button>
                    </li>
                </ul>
            </div>
        </div>
    </h1>

    <div [ngClass]="{ content: true, 'modal-body': modalMode }">
        <div class="questionnaire">

            <!-- Preview Mode -->
            <h1 *ngIf="previewMode">{{ questionnaire.Title }}</h1>

            <!-- Form Mode -->
            <div *ngIf="!previewMode" class="row">
                <div class="col-sm-6" *ngIf="userForm && !DateHelpers.isMinDate(userForm.CompletedDate)">
                    Last modified by {{userForm.ModifiedBy}} ({{userForm.ModifiedDate | date: 'MM/dd/yyyy h:mm a'}})
                </div>
                <div class="col-sm-6" *ngIf="userForm && DateHelpers.isMinDate(userForm.CompletedDate)">
                    Form not completed.
                </div>
                <div class="col-sm-6 float-end">
                    <div ngbDropdown *ngIf="userFormDetails.UserFormHistory?.length > 0">
                        <button type="button" class="btn btn-info w-100" ngbDropdownToggle>History</button>
                        <div ngbDropdownMenu class="dropdown-menu">
                            <li *ngFor="let history of userFormDetails.UserFormHistory"  class="w-100" > 
                                <button type="button" class="w-100 dropdown-item" *ngIf="history.HistoryId == -1" (click)=loadCurrent() [disabled]="!IsHistory">
                                    Current - {{ history.ModifiedDate | date: 'MMMM dd, yyyy h:mm a' }} - {{history.ModifiedBy}}
                               </button>
                                <button type="button"  class="w-100 dropdown-item" *ngIf="history.HistoryId != -1" (click)=loadHistory(history.HistoryId)>
                                     {{ history.ModifiedDate | date: 'MMMM dd, yyyy h:mm a' }} - {{history.ModifiedBy}}
                                </button>
                            </li>
                        </div>
                    </div>
                </div>
            </div>

            <section *ngFor="let section of questionnaire?.Sections ">
                <h2 *ngIf="section.DisplayTitle">{{ section.Title }}</h2>

                <aside *ngFor="let question of section.Questions">
                    <label class="form-label">{{ question.Label }} <span class="required" *ngIf="question.Required">*</span></label>

                    <div class="question edl-label"
                         *ngIf="question.TypeID === Type.LABEL">
                        <p [innerHtml]="question.AnswerConfig.Prefill?question.AnswerConfig.Prefill:''"></p>
                    </div>

                    <div class="question edl-label"
                        *ngIf="question.TypeID === Type.CALCULATION">
                        <input type="text" class="form-control"
                               [readonly]="true"
                               formControlName="{{ 'Question_' + question.QuestionID.toString() }}"/>
                    </div>

                    <div class="question edl-datepicker col-sm-6"
                         *ngIf="question.TypeID === Type.DATEPICKER">
                         <edl-date-picker
                            [disableInput]="question.ReadOnly || isFormLocked()"
                            formControlName="{{ 'Question_' + question.QuestionID.toString() }}"></edl-date-picker>
                    </div>

                    <div class="question edl-text"
                         *ngIf="question.TypeID === Type.TEXTITEM">
                        <input type="text" class="form-control"
                               (change)="this.recalculate(question.QuestionID)"
                               [placeholder]="question.AnswerConfig.Prefill?question.AnswerConfig.Prefill:''"
                               [readonly]="question.ReadOnly || isFormLocked()"
                               formControlName="{{ 'Question_' + question.QuestionID.toString() }}"/>
                    </div>

                    <div class="question edl-multiline-text"
                         *ngIf="question.TypeID === Type.PARAGRAPH">
                        <textarea *ngIf="!printMode" class="form-control"
                              [readonly]="question.ReadOnly || isFormLocked()"
                              [placeholder]="question.AnswerConfig.Prefill?question.AnswerConfig.Prefill:''"
                              formControlName="{{ 'Question_' + question.QuestionID.toString() }}"></textarea>
                        <p *ngIf="printMode" [innerHtml]="form.get('Question_' + question.QuestionID.toString()).value"></p>
                    </div>

                    <div class="question edl-multiple-choice"
                         *ngIf="question.TypeID === Type.MULTIPLECHOICE">
                        <ul [ngClass]="{'horizontal': question.AnswerConfig.Horizontal}">
                            <li *ngFor="let optionValue of question.AnswerConfig.OptionValues">
                                <label class="form-label">
                                    <fieldset [disabled]="question.ReadOnly || isFormLocked()">
                                        <input type="radio"
                                            (change)="this.recalculate(question.QuestionID)"
                                            [value]="optionValue.optionValue"
                                            [checked]="!!userForm && optionValue.optionValue === userForm.FormAnswers[question.QuestionID]"
                                            formControlName="{{ 'Question_' + question.QuestionID.toString() }}"/> {{ optionValue.optionValue }}
                                    </fieldset>
                                </label>
                            </li>
                        </ul>
                    </div>

                    <div class="question edl-checkbox"
                         *ngIf="question.TypeID === Type.CHECKBOX">
                        <ul>
                            <li *ngFor="let optionValue of question.AnswerConfig.OptionValues">
                                <label class="form-label">
                                    <input type="checkbox"
                                           [(ngModel)]="optionValue.isChecked"
                                           [(checklist)]="checkboxQuestions['Question_' + question.QuestionID.toString()]"
                                           [disabled]="question.ReadOnly || isFormLocked()"
                                           [ngModelOptions]="{ standalone: true }"
                                           [value]="optionValue.control"/> {{ optionValue.optionValue }}
                                </label>
                            </li>
                        </ul>
                    </div>

                    <div class="question edl-dropdown"
                         *ngIf="question.TypeID === Type.DROPDOWN">
                        <select class="form-select" (change)="this.recalculate(question.QuestionID)" formControlName="{{ 'Question_' + question.QuestionID.toString() }}">
                            <option value="" [disabled]="question.ReadOnly || isFormLocked()">Select</option>
                            <option *ngFor="let optionValue of question.AnswerConfig.OptionValues" [value]="optionValue.optionValue" [disabled]="question.ReadOnly || isFormLocked()">
                                {{ optionValue.optionValue }}
                            </option>
                        </select>
                    </div>

                    <div class="question edl-signature" *ngIf="question.TypeID === Type.SIGNATURE">
                        <div class="row">
                            <div class="col-sm-12">
                                <edl-signature-pad
                                    [signaturePadOptions]="signaturePadOptions"
                                    [disableInput]="question.ReadOnly || isFormLocked() || overrideForm"
                                    formControlName="{{ 'Question_' + question.QuestionID.toString() }}"></edl-signature-pad>
                            </div>
                        </div>
                        <div class="row" *ngIf="!question.ReadOnly && !isFormLocked()">
                            <div class="col-sm-12">
                                <button type="button" class="btn btn-info" (click)="clearSignature(question.QuestionID)" [disabled]="question.ReadOnly || isFormLocked() || overrideForm">Clear</button>
                            </div>
                        </div>
                    </div>
                </aside>
            </section>
        </div>
    </div>
</form>